/**
 * @file useOperatorCurrency
 * Hook that provides currency formatting based on operator settings
 */

import { useOperator } from "./useOperator";
import { currency as currencyHelper } from "utils/helpers";

function useOperatorCurrency(): (money: number) => string {
  const { operator } = useOperator();
  const currencyCode = operator?.settings?.currencyCode;

  const currency = (money: number) => currencyHelper(money, currencyCode);

  return currency;
}

export { useOperatorCurrency };
